export const KIA_LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_kia-dealer-hub/artifacts/znp3ko48_image.png";

const SPOTLIGHT = "https://assets.spotlighthyperlocal.com/assets/3dc7de01-597d-4a2c-9e23-6a70769bacad/products";

export const MODELS = [
  {
    id: "sonet",
    name: "Kia Sonet",
    tagline: "The Wild. Reborn.",
    category: "SUV",
    price: "₹7.41 Lakh*",
    priceRaw: 740900,
    fit: "contain",
    specs: {
      Engine: "1.0L Turbo GDi / 1.2L Petrol / 1.5L Diesel",
      Power: "120 PS",
      Transmission: "7DCT / 6iMT / 5MT",
      Safety: "Robust 15 Hi-Safety Features Standard",
      Seating: "5 Seater",
      Highlights: "ADAS with 10 Autonomous Features, Bose 7-Speaker Sound, Kia Connect",
    },
    image: `${SPOTLIGHT}/cfbaf612-5d12-4639-a2ba-78d9c01f7675.png`,
    badge: "COMPACT KING",
  },
  {
    id: "syros",
    name: "Kia Syros",
    tagline: "Something for Everyone.",
    category: "SUV",
    price: "₹8.42 Lakh*",
    priceRaw: 841900,
    fit: "contain",
    specs: {
      Engine: "1.2L Smartstream Petrol / 1.5L CRDi Diesel",
      Power: "115 PS",
      Transmission: "6MT / 7DCT / 6AT",
      Display: "30-inch Trinity Panoramic Display",
      Seating: "5 Seater",
      Highlights: "Sliding & Reclining Ventilated Rear Seats, Harman Kardon 8-Speaker, Dual Pane Sunroof",
    },
    image: `${SPOTLIGHT}/f07f7437-2075-4cba-b7bf-eac9878912d6.png`,
    badge: "NEW LAUNCH",
  },
  {
    id: "seltos",
    name: "New Kia Seltos",
    tagline: "Bigger. Bolder. More Progressive.",
    category: "SUV",
    price: "₹10.99 Lakh*",
    priceRaw: 1099900,
    fit: "contain",
    specs: {
      Engine: "1.5L Turbo GDi / 1.5L CRDi",
      Power: "160 PS",
      Transmission: "6MT / 7DCT / IVT / 6iMT",
      Design: "Digital Tiger Face with Flush Door Handles",
      Seating: "5 Seater",
      Highlights: "ADAS Level 2 (21 Features), Panoramic Sunroof, Star Map LED Tail Lamps",
    },
    image: `${SPOTLIGHT}/76e3f69a-7f79-44dc-a920-d49b234b5c05.png`,
    badge: "MOST POPULAR",
  },
  {
    id: "carens",
    name: "Kia Carens",
    tagline: "From a Different World.",
    category: "Family MPV",
    price: "₹11.12 Lakh*",
    priceRaw: 1111900,
    fit: "contain",
    specs: {
      Engine: "1.5L Turbo GDi / 1.5L Diesel",
      Power: "160 PS",
      Transmission: "6MT / 7DCT / 6AT",
      Safety: "Robust 15 Hi-Safety Features Standard",
      Seating: "6 / 7 Seater Options",
      Highlights: "One-Touch Electric Tumble Seats, Ventilated Seats, Kia Connect (66 Features)",
    },
    image: `${SPOTLIGHT}/5db01da4-ceb9-4ef6-bd67-1a3665b492d1.png`,
    badge: "FAMILY FAVOURITE",
  },
  {
    id: "carens-clavis",
    name: "Kia Carens Clavis",
    tagline: "For Epic Journeys.",
    category: "Family MPV",
    price: "₹11.39 Lakh*",
    priceRaw: 1138900,
    fit: "contain",
    specs: {
      Engine: "1.5L T-GDi Turbo / 1.5L Petrol / 1.5L CRDi VGT Diesel",
      Power: "160 PS",
      Transmission: "6MT / 7DCT / 6AT",
      Display: "Twin Panoramic Digital Cockpit",
      Seating: "6 / 7 Seater",
      Highlights: "BOSE Premium Sound, Ventilated Front Seats, 360° Camera, ADAS",
    },
    image: `${SPOTLIGHT}/6b8e7077-3e51-4036-b373-675e1042d98f.png`,
    badge: "EPIC JOURNEYS",
  },
  {
    id: "syros-ev",
    name: "Kia Syros EV",
    tagline: "Superior Beyond Belief.",
    category: "Electric",
    price: "₹13.50 Lakh*",
    priceRaw: 1349900,
    fit: "contain",
    specs: {
      Display: "30-inch Trinity Panoramic Display Panel",
      Connectivity: "Kia Connect 2.0 with OTA Updates",
      Key: "Digital Key 2.0 with Touch, Watch & Share",
      Power_Bank: "V2L – Vehicle-to-Load (External)",
      Seating: "5 Seater",
      Highlights: "Rear Seat Sliding & Reclining with Ventilation, Dual Pane Panoramic Sunroof",
    },
    image: `${SPOTLIGHT}/496a0373-c485-4188-bb3c-290709d8483c.png`,
    badge: "100% ELECTRIC",
  },
  {
    id: "carens-clavis-ev",
    name: "Kia Carens Clavis EV",
    tagline: "It's an E.We",
    category: "Electric",
    price: "₹18.04 Lakh*",
    priceRaw: 1803900,
    fit: "contain",
    specs: {
      Storage: "25L Frunk (Front Trunk)",
      Lighting: "Star Map Connected DRLs & Tail Lamps",
      Power_Bank: "V2L External & Internal Ports",
      Regen: "Paddle Shifter Regen Control",
      Seating: "7 Seater Electric MPV",
      Highlights: "Active Air Flaps, Aero Dual-Tone Alloys, Dual Pane Sunroof",
    },
    image: `${SPOTLIGHT}/cd764040-f55a-4ad0-b2d9-8735ba47c4ee.png`,
    badge: "ELECTRIC MPV",
  },
  {
    id: "sorento",
    name: "Kia Sorento",
    tagline: "Global Icon. Reimagined for India.",
    category: "Performance SUV",
    price: "₹27.99 Lakh*",
    priceRaw: 2799000,
    fit: "contain",
    specs: {
      Powertrain: "Advanced Hybrid Technology",
      Assistance: "Thoughtful Intelligence at Your Command",
      Capability: "Confidence on Every Road",
      Display: "12.3-inch Curved Dual Display",
      Seating: "7 Seater",
      Highlights: "Real-Time Smart Assistance, Smoother & Cleaner Hybrid Performance",
    },
    image: `${SPOTLIGHT}/34300288-0012-4fed-b4ff-de112e1f7af2.png`,
    badge: "FLAGSHIP SUV",
  },
  {
    id: "carnival",
    name: "Kia Carnival",
    tagline: "Your Own Luxury Liner.",
    category: "Luxury MPV",
    price: "₹59.65 Lakh*",
    priceRaw: 5964900,
    fit: "contain",
    specs: {
      Engine: "2.2L CRDi VGT Diesel",
      Doors: "Smart Power Sliding Doors & Tailgate",
      Display: "Dual 12.3-inch Panoramic Curved Displays + 11-inch HUD",
      Seating: "7 Seater Luxury Lounge",
      Sound: "12-Speaker BOSE Premium Sound",
      Highlights: "2nd Row Powered Seats with Ventilation & Heating, 8 Airbags, 360° Camera",
    },
    image: `${SPOTLIGHT}/4e1aff2d-c469-4613-9696-ec048225c387.png`,
    badge: "LUXURY LINER",
  },
  {
    id: "ev6",
    name: "Kia EV6",
    tagline: "Electrified GT Performance",
    category: "Electric",
    price: "₹60.95 Lakh*",
    priceRaw: 6095000,
    fit: "cover",
    specs: {
      Range: "708 km (WLTP certified)",
      Acceleration: "0-100 km/h in 5.2s",
      Battery: "77.4 kWh Lithium-ion",
      Charging: "800V Ultra-Fast (10-80% in 18 mins)",
      Seating: "5 Seater Crossover",
      Highlights: "Augmented Reality HUD, Meridian 14-Speaker Sound, AWD Dual Motor",
    },
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/da/Kia_EV6_CV1_PE_Interstellar_Gray_%282%29.jpg/1280px-Kia_EV6_CV1_PE_Interstellar_Gray_%282%29.jpg",
    badge: "ELECTRIC GT",
  },
  {
    id: "ev9",
    name: "Kia EV9",
    tagline: "World Car of the Year 2024",
    category: "Electric",
    price: "₹1.30 Crore*",
    priceRaw: 13000000,
    fit: "cover",
    specs: {
      Range: "561 km",
      Acceleration: "0-100 km/h in 5.3s",
      Battery: "99.8 kWh Battery Pack",
      Charging: "350kW Fast Charging (249 km in 15 mins)",
      Seating: "6 Seater Swivel Lounge",
      Highlights: "Fingerprint Recognition, Swiveling 2nd Row Seats, Remote Smart Parking 2",
    },
    image: "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f8/Kia_EV9_GT-Line_MV1_Panthera_Metal_%282%29.jpg/1280px-Kia_EV9_GT-Line_MV1_Panthera_Metal_%282%29.jpg",
    badge: "WORLD CAR OF THE YEAR",
  },
];

export const FILTERS = [
  { id: "all", label: "All Models", match: () => true },
  { id: "suv", label: "SUV", match: (m) => ["SUV", "Performance SUV"].includes(m.category) },
  { id: "electric", label: "Electric", match: (m) => m.category === "Electric" },
  { id: "mpv", label: "MPV", match: (m) => ["Family MPV", "Luxury MPV"].includes(m.category) },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Architecture of Motion",
    subtitle: "Opposites United Design Philosophy",
    content:
      "Kia's Opposites United design ethos takes inspiration from the contrasts found in nature and humanity. Every curve on a Sanjib Kia delivered vehicle is sculpted to channel air with razor precision while casting an unmistakable presence on Indian roads.",
  },
  {
    number: "02",
    title: "The Digital Tiger DNA",
    subtitle: "Star Map Illumination & ADAS Level 2+",
    content:
      "From the iconic Digital Tiger Nose grille to Star Map LED light signatures, Kia engineering connects foresight with safety. Active radar matrix, lane keep assist, and autonomous emergency braking — absolute peace of mind on Odisha's highways.",
  },
  {
    number: "03",
    title: "The Sanjib Experience",
    subtitle: "VIP Concierge & Home Doorstep Test Drive",
    content:
      "As Jajpur's trusted Kia dealership — Sanjib Rideway (P) Ltd. on NH-20 Panikoili — we turn car buying into a celebratory milestone. Hassle-free exchange, best price for your old car, instant finance, and white-glove doorstep delivery.",
  },
  {
    number: "04",
    title: "Electric Freedom",
    subtitle: "E-GMP Platform & 800V Hyper Charging",
    content:
      "Step confidently into the EV era with the Syros EV, Carens Clavis EV, EV6, and EV9. Backed by Sanjib Kia's EV-ready showroom infrastructure and dedicated electric vehicle master technicians.",
  },
];

export const DEALERSHIP = {
  name: "Sanjib Kia",
  legal: "Sanjib Rideway (P) Ltd.",
  address: "NH-20, Panikoili, Jajpur, Odisha — 755019",
  phone: "+91 91673 13237",
  phoneRaw: "+919167313237",
  whatsapp: "919556744001",
  email: "sales@sanjibkia.com",
  hours: "Mon – Sun · 9:00 AM – 8:00 PM",
  services: ["New Car Sales", "Hassle-Free Exchange", "Finance & Insurance", "Test Drives", "Genuine Accessories", "Service & Maintenance"],
};

export const MARQUEE_ITEMS = [
  "Movement That Inspires",
  "Sanjib Kia · Jajpur",
  "New Seltos — Badass Forever",
  "Syros EV · Superior Beyond Belief",
  "Carnival — Your Luxury Liner",
  "Sorento · Global Icon",
  "Carens Clavis — For Epic Journeys",
  "Sonet — The Wild Reborn",
];

export const TIME_SLOTS = ["10:00 AM", "12:00 PM", "2:00 PM", "4:00 PM", "6:00 PM"];
